import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { NgbActiveModal, NgbModalRef, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { SERVER_DATE_TIME_FORMAT } from '../../shared/constants/date-time.constants';
import { EventManager, AlertService, JhiLanguageService, DateUtils } from 'ng-jhipster';

import { School } from './school.model';
import { SchoolPopupService } from './school-popup.service';
import { SchoolService } from './school.service';
import { Principal, TimeZoneService, DateUtilities } from '../../shared/index';
import { StateStorageService } from '../../shared/auth/state-storage.service';
import { AbstractGeograpicalDialogComponent } from '../abstract-dialog-component/abstract-geopraphical-dialog.component';
import { CountryService } from '../country';
import { CityService } from '../city';
import { TaxService } from '../tax';


@Component({
    selector: 'jhi-school-dialog',
    templateUrl: './school-dialog.component.html'
})
export class SchoolDialogComponent extends AbstractGeograpicalDialogComponent implements OnInit {

    school: School;
    authorities: any[];
    timezones: string[];
    isSaving: boolean;
    navbarColor: string;
    footerColor: string;
    backgroundColor: string;
    subscriptionEndDate: NgbDateStruct;
    previousInvoiceStartingNumber: number;
    finalInvoiceCount: number;
    disableEditStartingInvoiceNumber: boolean;

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        protected alertService: AlertService,
        protected schoolService: SchoolService,
        private timezoneService: TimeZoneService,
        private eventManager: EventManager,
        private datePipe: DatePipe,
        protected principal: Principal,
        private dateUtils: DateUtils,
        private stateStorageService: StateStorageService,
        protected countryService: CountryService,
        protected cityService: CityService,
        protected taxService: TaxService
    ) {
        super(countryService, cityService, taxService, schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['school']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_SCHOOL_ADMIN', 'ROLE_ADMIN'];
        this.timezoneService.query().subscribe(
            (res: any) => {
                let zoneIds = res;
                if (zoneIds) {
                    this.timezones = zoneIds.sort((a, b) => ('' + a).localeCompare(b));
                }
            },
            (res: HttpErrorResponse) => this.onError(res)
            );

        this.navbarColor = this.schoolService.getColor('navbar');
        this.footerColor =  this.schoolService.getColor('footer');
        this.backgroundColor = this.schoolService.getColor('background');
        this.loadGeographicalLocations(this.school != null ? this.school.countryId : null);
        this.subscriptionEndDate = DateUtilities.toDateStruct(this.school.subscriptionEndDate);
        this.previousInvoiceStartingNumber = this.school.startingInvoiceNumber;
        this.disableEditStartingInvoiceNumber =  this.previousInvoiceStartingNumber > 0;
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        this.school.navbarColor = this.navbarColor.slice(1);
        this.school.footerColor = this.footerColor.slice(1);
        this.school.backgroundColor = this.backgroundColor.slice(1);
        let subscriptionEnd: Date = new Date();
        subscriptionEnd.setDate(this.subscriptionEndDate.day);
        subscriptionEnd.setMonth(this.subscriptionEndDate.month - 1);
        subscriptionEnd.setFullYear(this.subscriptionEndDate.year);
        this.school.subscriptionEndDate = this.datePipe
        .transform(subscriptionEnd, SERVER_DATE_TIME_FORMAT);
        this.school.subscriptionEndDate = this.dateUtils.toDate(this.school.subscriptionEndDate);
        this.trimSchoolUrlFields();

        this.principal
            .hasAnyAuthority(['ROLE_ADMIN'])
            .then(isPlatformAdmin => {
                if (isPlatformAdmin) {
                    if (this.school.id !== undefined) {
                        this.schoolService.update(this.school)
                            .subscribe((res: School) =>
                                this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
                    } else {
                        this.schoolService.create(this.school)
                            .subscribe((res: School) =>
                                this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
                    }
                } else {
                    // The current user not a platform admin, he can update only his school
                    this.schoolService.updateCurrent(this.school)
                            .subscribe((res: School) =>
                                this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
                }
            });

    }

    private trimSchoolUrlFields () {
        if (!this.school.facebookUrl || this.school.facebookUrl.trim() === '') {
            this.school.facebookUrl = null;
        }
        if (!this.school.instagramUrl || this.school.instagramUrl.trim() === '') {
            this.school.instagramUrl = null;
        }
        if (!this.school.youtubeUrl || this.school.youtubeUrl.trim() === '') {
            this.school.youtubeUrl = null;
        }
        if (!this.school.websiteUrl || this.school.websiteUrl.trim() === '') {
            this.school.websiteUrl = null;
        }
        if (!this.school.supportUrl || this.school.supportUrl.trim() === '') {
            this.school.supportUrl = null;
        }
        if (!this.school.tiktokUrl || this.school.tiktokUrl.trim() === '') {
            this.school.tiktokUrl = null;
        }
    }

    private onSaveSuccess(result: School) {
        this.eventManager.broadcast({ name: 'schoolListModification', content: 'OK' });
        this.eventManager.broadcast({ name: 'navbarColorModification', content: this.school.navbarColor });
        this.eventManager.broadcast({ name: 'backgroundColorModification', content: this.school.backgroundColor });
        this.eventManager.broadcast({ name: 'footerColorModification', content: this.school.footerColor });
        this.isSaving = false;
        this.activeModal.dismiss(result);

        // we update the timezone of the current session
        this.stateStorageService.setCurrentTimezone(result.timezone);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    private setAcceptOnlinePayment() {
        this.school.acceptOnlinePayments = !this.school.onlinePaymentsModuleEnabled && this.school.acceptOnlinePayments;
    }
}

@Component({
    selector: 'jhi-school-popup',
    template: ''
})
export class SchoolPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private schoolPopupService: SchoolPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.schoolPopupService
                    .open(SchoolDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.schoolPopupService
                    .open(SchoolDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school/school-dialog.component.ts